export function formatBytes(bytes: number, decimals = 1): string {
  if (!bytes || bytes <= 0) return '0 B';
  const k = 1024;
  const sizes = ['B', 'KB', 'MB', 'GB', 'TB', 'PB'];
  const i = Math.floor(Math.log(bytes) / Math.log(k));
  return `${parseFloat((bytes / Math.pow(k, i)).toFixed(decimals))} ${sizes[i]}`;
}

export function formatDate(ts: number | null | undefined): string {
  if (!ts) return '—';
  return new Date(ts).toLocaleString('zh-CN', { year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit' });
}

export function isImage(mime?: string | null): boolean {
  return !!mime?.startsWith('image/');
}
export function isVideo(mime?: string | null): boolean {
  return !!mime?.startsWith('video/');
}
export function isAudio(mime?: string | null): boolean {
  return !!mime?.startsWith('audio/');
}
export function isPdf(mime?: string | null): boolean {
  return mime === 'application/pdf';
}
export function isText(mime?: string | null): boolean {
  return !!mime && (mime.startsWith('text/') || ['application/json', 'application/xml', 'application/javascript'].includes(mime));
}

export function fileIcon(mime?: string | null, name?: string): string {
  if (!mime) return 'file';
  if (mime.startsWith('image/')) return 'image';
  if (mime.startsWith('video/')) return 'video';
  if (mime.startsWith('audio/')) return 'audio';
  if (mime === 'application/pdf') return 'pdf';
  if (mime === 'application/zip' || mime === 'application/x-tar' || mime === 'application/x-7z-compressed' || mime === 'application/gzip') return 'archive';
  if (mime === 'application/vnd.ms-excel' || mime === 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet') return 'sheet';
  if (mime.startsWith('text/') || ['application/json', 'application/xml', 'application/javascript'].includes(mime)) return 'text';
  return 'file';
}

export function humanizeError(err: any): string {
  return err?.message || '操作失败';
}

export function fileNameNoExt(name: string): string {
  const idx = name.lastIndexOf('.');
  if (idx <= 0) return name;
  return name.slice(0, idx);
}

export function extOf(name: string): string {
  const idx = name.lastIndexOf('.');
  return idx >= 0 ? name.slice(idx + 1).toLowerCase() : '';
}
